import { fetchHotel, fetchVoucherHotel } from '@/api/service'

const getPaxsHotel = (context) => {
  return fetchHotel().then((response) => {
    const vouchers = Array.isArray(response?.vouchers) ? response.vouchers : []
    const firstVoucher = vouchers.length ? vouchers[0] : {}
    // context.commit('PAXSHOTEL_ROOMS_FETCH', vouchers)
    context.commit('PAXSHOTEL_FETCH', firstVoucher)
    return response
  })
}

const getVoucherHotel = (context, paxVoucherId) => {
  if (paxVoucherId) {
    return fetchVoucherHotel(paxVoucherId).then((response) => {
      response = !_.isUndefined(response) ? response : {}
      const rooms = Array.isArray(response.vouchers) ? response.vouchers : Array.isArray(response) ? response : [response]
      const firstRoom = rooms.length ? rooms[0] : {}
      context.commit('PAXSHOTEL_ROOMS_FETCH', rooms)
      context.commit('PAXSHOTEL_FETCH', firstRoom)
      return response
    })
  }
}

export default {
  getPaxsHotel,
  getVoucherHotel
}
